/**
 * Abstract animated "hotspot" map — stylized dot grid across the U.S. silhouette
 * with a few pulsing red-orange nodes. Pure SVG/CSS, no real geographic data.
 */
export const HotspotMap = () => {
    // Pre-computed dot positions (hand-tuned to resemble a U.S.-ish blob shape)
    const dots = [];
    const cols = 32;
    const rows = 14;
    for (let r = 0; r < rows; r++) {
        for (let c = 0; c < cols; c++) {
            // shape mask — center bulge
            const x = c / cols;
            const y = r / rows;
            const dx = x - 0.5;
            const dy = y - 0.5;
            const dist = Math.sqrt(dx * dx + dy * dy * 1.8);
            if (dist < 0.42 && Math.random() > 0.18) {
                dots.push({ cx: c * 32 + 16, cy: r * 32 + 16 });
            }
        }
    }

    const hotspots = [
        { cx: 180, cy: 200 },
        { cx: 360, cy: 160 },
        { cx: 540, cy: 260 },
        { cx: 720, cy: 200 },
        { cx: 880, cy: 240 },
        { cx: 460, cy: 320 },
    ];

    return (
        <svg
            viewBox="0 0 1024 448"
            preserveAspectRatio="xMidYMid meet"
            className="w-full h-full"
            aria-hidden="true"
        >
            {dots.map((d) => (
                <circle
                    key={`d-${d.cx}-${d.cy}`}
                    cx={d.cx}
                    cy={d.cy}
                    r="1.5"
                    fill="rgba(255,255,255,0.18)"
                />
            ))}
            {hotspots.map((h, i) => (
                <g key={`h-${h.cx}-${h.cy}`} style={{ transformOrigin: `${h.cx}px ${h.cy}px` }}>
                    <circle
                        cx={h.cx}
                        cy={h.cy}
                        r="6"
                        fill="#F0493E"
                        className="hotspot-core"
                        style={{ animationDelay: `${i * 0.4}s` }}
                    />
                    <circle
                        cx={h.cx}
                        cy={h.cy}
                        r="6"
                        fill="none"
                        stroke="#F0493E"
                        strokeWidth="1.5"
                        className="hotspot-pulse"
                        style={{ animationDelay: `${i * 0.4}s` }}
                    />
                </g>
            ))}
        </svg>
    );
};
